import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import PageAction from '../../../components/PageAction';
import PageTitle from '../../../components/PageTitle';
import TableBasic from '../../../components/Tablebasic';
import { useHealthAuthority } from '../../../hooks';
import { breachcrumbPath } from '../../../utils/breadcrumbConst';

const HealthAuthority = () => {
  const location: any = useLocation();
  const {
    healthAuthorities,
    selectedHealthAuthorities,
    getHealthAuthorities,
    handleCheck,
    selectedValue,
    setSelectedValue,
    handleMenuAction,
  } = useHealthAuthority();

  const [toastMessage, setToastMessage] = useState<IToastMessage>();

  useEffect(() => {
    getHealthAuthorities();
  }, []);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastMessage(location.state.toastMessage);
    }
  }, [location]);

  return (
    <AppWrapper
      toastMessage={toastMessage}
      breadcrumbs={[breachcrumbPath.core, breachcrumbPath.healthAuthority]}
    >
      <PageTitle
        title="Select health authority to change"
        linkUrl="/core/healthauthority/add"
        buttonText="add health authority"
        useIcon
        showButton
      />
      <PageAction
        name="health authority"
        count={healthAuthorities.length}
        selectedCount={selectedHealthAuthorities.length}
        selectedValue={selectedValue}
        onChange={setSelectedValue}
        handleClick={handleMenuAction}
      />
      <TableBasic
        data={healthAuthorities || []}
        selectedList={selectedHealthAuthorities}
        handleCheck={handleCheck}
        footerText={`${healthAuthorities.length} Health Authorites`}
        basicUrl="/core/healthauthority"
      />
    </AppWrapper>
  );
};

export default HealthAuthority;
